import { Injectable } from '@angular/core';
import {
	HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpErrorResponse
} from '@angular/common/http';

import { Observable, firstValueFrom, from, lastValueFrom, map, mapTo, of, tap } from 'rxjs';
import { ConfigService } from '../Services/ConfigService';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	constructor(
		private _authService: AuthService,
		private _router: Router,
		private configData: ConfigService
	) {

	}

	authRenew(): Observable<boolean> {
		if (this._authService.isAuthedButExpired()) {
			return from(this._authService.updateUserInfo()
				.then(() => {
					return this._authService.isAuthenticated()
				}));;
		} else {
			return of(true);
		}
	}
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return from(this.innerIntercept(req, next));
	}
	async innerIntercept(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
		if (req.url.startsWith(this.configData.apiBaseUrl())) {
			const newheaders = this.getMyHeaders();
			const authorizedRequest = req.clone({ headers: newheaders });
			var isOk = await firstValueFrom(this.authRenew());
			return lastValueFrom(next.handle(authorizedRequest)
				.pipe(
					tap(
						() => { },
						error => {
							var respError = error as HttpErrorResponse;
							if (respError && respError.status == 401) {
								this._authService.login();
							}
						}
					)
				)
			);
		} else {
			return lastValueFrom(next.handle(req));
		}
	}

	getMyHeaders(): HttpHeaders {

		var headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'If-Modified-Since': 'Mon, 1 Jan 1990 00:00:00 GMT',
			'Cache-Control': 'no-cache',
			'Pragma': 'no-cache',
			'X-Requested-With': 'XMLHttpRequest'
		}); // ... Set content type to JSON
		if (!this.configData.IsEmptyGuid(this.configData.companyID)) {
			headers = headers.set("CompanyID", this.configData.companyID.toString());
		}

		if (this.configData.isLoggedIn()) {
			headers = headers.set("Authorization", `${this.configData.user.token_type} ${this.configData.user.access_token}`);
		}
		return headers;
	}
}
